export type PendingFile = {
    id: string;
    name: string;
    file: File;
};

export type TCommentItemApiType = Exclude<CommentItemType, CommentItemType.DRAFT_COMMENT>;

export enum CommentItemType {
    DRAFT_COMMENT = 'draftComment',
    ESCALATION_RAISED = 'escalationRaised',
    EMAIL_SENT = 'emailSent',
    COMMENT_ADDED = 'commentAdded',
    STATUS_CHANGED = 'statusChanged',
}

export enum SendEmailPayload {
    FLAG_SEND_MAIL = 'flagSendMail',
    EMAIL_TO = 'emailTo',
    EMAIL_CC = 'emailCc',
    EMAIL_SUBJECT = 'emailSubject',
    EMAIL_BODY = 'emailBody'
}